// AUTO-GENERATED from config/google-oauth.json by scripts/generate-google-oauth.mjs.
// DO NOT EDIT BY HAND. Run `node scripts/generate-google-oauth.mjs` to regenerate; CI fails on drift.
//
// The Google sign-in client ID is public by construction (it ships in this very bundle and is
// sent to Google on every sign-in), so it is committed rather than injected from a secret —
// see config/google-oauth.json for the 2026-09-09 incident that made that the rule here.

/** The OAuth client the browser presents to Google. Registered for every origin we serve. */
export const GOOGLE_WEB_CLIENT_ID = "205360336037-kd07ma25pjri7up1dpk0dk5on5vrki7r.apps.googleusercontent.com";

/** JavaScript origins registered on that client in the Google Cloud Console. */
export const GOOGLE_AUTHORIZED_ORIGINS: readonly string[] = [
  "https://prest0.ai",
  "https://www.prest0.ai",
  "http://localhost:3000",
];

/** Client IDs that must never be presented again — each one broke sign-in somewhere. */
export const GOOGLE_RETIRED_CLIENT_IDS: readonly string[] = [
  "205360336037-5aci9fbt8apt9lsu3g7qvv31622nfqf6.apps.googleusercontent.com",
];

export const GOOGLE_OAUTH_SSOT_VERSION = "1";
